export default [
	{
        path: '/login',
        name: 'login',
        component: () => import(
            /* webpackChunkName: "login" */ './../views/Login.vue'
        ),
        meta: {
            quest: true
        }
    },
	{
        path: '/recuperar-senha',
        name: 'passwordRecovery',
        component: () => import(
            /* webpackChunkName: "login" */ './../views/PasswordRecovery.vue'
        ),
        meta: {
            quest: true
        }
    },
	{
        path: '/alterar-senha',
        name: 'changePassword',
        component: () => import(
            /* webpackChunkName: "login" */ './../views/ChangePassword.vue'
        ),
        meta: {
            quest: true
        }
    },
];